// Phone roster tabs (Week / List / Month) — the same for staff and admins.
// The last one chosen is stored per user on this device.

export const MOBILE_VIEWS = ['week', 'list', 'calendar'];

const LEGACY_KEY = 'leuchtstoff_mobileView'; // before: one value per device

export const mobileViewKey = (userId) => `leuchtstoff_mobileView_${userId ?? 'anon'}`;

export function readMobileView(userId) {
  try {
    const v = localStorage.getItem(mobileViewKey(userId)) || localStorage.getItem(LEGACY_KEY);
    return MOBILE_VIEWS.includes(v) ? v : 'week';
  } catch {
    return 'week';
  }
}

export function saveMobileView(userId, view) {
  try { localStorage.setItem(mobileViewKey(userId), view); } catch { /* private mode */ }
}
